import { createStore } from "@methodjs/store";

const initErrorState = () => false;

const [useErrorStore, setErrorStore, getErrorStore] =
  createStore(initErrorState);

export { useErrorStore, setErrorStore, getErrorStore };
